import { Box, Card, CardActions, CardContent, CardHeader, Collapse, Grid, makeStyles, Menu, MenuItem, useTheme } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import GenericButton from "components/Buttons/GenericButton";
import FormDatePickerV2 from "components/FormFields/FormDatePickerV2";
import FormDropdown from "components/FormFields/FormDropdown";
import FormInput from "components/FormFields/FormInput";
import { useCallback, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import getDataSetByNameAction from "redux/actions/datasetsAction";
import { DATASET, REPORT_FILE_NAME } from "utils/const";

const useStylesGeneric = makeStyles((theme) => ({
  root: {
    boxShadow: "0px 6px 6px 0px #00000026",
  },

  title: {
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "36px",
    textAlign: "left",
    color: theme.palette.primary.main,
  },

  actions: {
    justifyContent: "flex-end",
    borderTop: "none !important",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      rowGap: theme.spacing(1),
      paddingLeft: `${theme.spacing(1)}px !important`,
      paddingRight: `${theme.spacing(1)}px !important`,
    },
  },

  exportWrapper: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}));

const FilterSection = ({ onSubmit: onSubmitFilters, onReset: onResetFilters, onExport, exportDisabled }) => {
  const classes = useStylesGeneric();
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    control,
    handleSubmit,
    getValues,
    trigger,
    formState: { errors },
  } = useFormContext();

  const [expanded, setExpanded] = useState(false);

  const [exportMenuAnchorEl, setExportMenuAnchorEl] = useState(null);
  const exportMenuOpen = Boolean(exportMenuAnchorEl);

  const handleOpenExportMenu = (event) => {
    setExportMenuAnchorEl(event.currentTarget);
  };

  const handleCloseExportMenu = () => {
    setExportMenuAnchorEl(null);
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const datasets = useSelector((state) => state.datasetsState);
  const dispatch = useDispatch();

  const getDataSetByName = useCallback(
    (name, parentKeyValue) => dispatch(getDataSetByNameAction(name, parentKeyValue)),
    [dispatch]
  );

  useEffect(() => {
    getDataSetByName(DATASET.MAP_RENT_STATES);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = async () => {
    if (onSubmitFilters) {
      await onSubmitFilters();
    }
  };

  const handleReset = async () => {
    if (onResetFilters) {
      await onResetFilters();
    }
  };

  return (
    <Card className={classes.root} elevation={1}>
      <CardHeader
        classes={{
          title: classes.title,
        }}
        title={
          isSmDown ? (
            <Box display="flex" flexDirection="column" alignItems="flex-start">
              <Box>Pesquisa de Mapas RENT</Box>
              <GenericButton onClick={handleExpandClick} color="ghost" fullWidth>
                {expanded ? "Esconder Filtros" : "Mostrar Filtros"}
              </GenericButton>
            </Box>
          ) : (
            "Pesquisa de Mapas RENT"
          )
        }
        action={
          isSmDown
            ? null
            : expanded
              ? (
                  <GenericButton onClick={handleExpandClick} color="ghost">
                    Esconder Filtros
                  </GenericButton>
                )
              : (
                  <GenericButton onClick={handleExpandClick} color="ghost">
                    Mostrar Filtros
                  </GenericButton>
                )
        }
      />

      <form id="filter-rent" onSubmit={handleSubmit(onSubmit)}>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <FormInput label="Nº do Mapa RENT" placeholder="Nº do Mapa RENT" name="name" control={control} />
              </Grid>

              <Grid item xs={12} md={4}>
                <FormDropdown
                  control={control}
                  name="stateId"
                  label="Estado"
                  options={datasets[DATASET.MAP_RENT_STATES]}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <FormDatePickerV2
                  name="startDate"
                  label="Data de Submissão (Desde)"
                  control={control}
                  maxDateToday={true}
                  minDateToday={false}
                  endDateFieldName="endDate"
                  errors={errors}
                  classes={classes}
                  trigger={trigger}
                  getValues={getValues}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <FormDatePickerV2
                  name="endDate"
                  label="Data de Submissão (Até)"
                  control={control}
                  maxDateToday={true}
                  minDateToday={false}
                  startDateFieldName="startDate"
                  errors={errors}
                  classes={classes}
                  trigger={trigger}
                  getValues={getValues}
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions className={classes.actions}>
            <GenericButton onClick={handleReset} color="ghost" fullWidth={isSmDown}>
              Limpar Filtros
            </GenericButton>
            <span className={classes.exportWrapper}>
              <GenericButton
                type="button"
                color="primary"
                onClick={handleOpenExportMenu}
                disabled={!!exportDisabled}
                fullWidth={isSmDown}
              >
                Exportar <KeyboardArrowDownIcon />
              </GenericButton>
              <Menu anchorEl={exportMenuAnchorEl} open={exportMenuOpen} onClose={handleCloseExportMenu} keepMounted>
                <MenuItem
                  onClick={() => {
                    handleCloseExportMenu();
                    onExport?.(REPORT_FILE_NAME.PDF_EXTENSION);
                  }}
                >
                  PDF
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleCloseExportMenu();
                    onExport?.(REPORT_FILE_NAME.EXCEL_EXTENSION);
                  }}
                >
                  Excel
                </MenuItem>
              </Menu>
            </span>
            <GenericButton type="submit" form="filter-rent" color="primary" fullWidth={isSmDown}>
              Pesquisar
            </GenericButton>
          </CardActions>
        </Collapse>
      </form>
    </Card>
  );
};

export default FilterSection;
